import { createContext, useContext } from "react";

export type WorkspaceValue = {
  projectIds: string[];
  addProject: (id: string) => void;
  removeProject: (id: string) => void;
};

export const WorkspaceContext = createContext<WorkspaceValue | null>(null);

export function useWorkspace() {
  const value = useContext(WorkspaceContext);
  if (!value) throw new Error("useWorkspace must be rendered inside WorkspaceContext");
  return value;
}
